import classNames from 'classnames';
import { Fragment, useCallback, useMemo } from 'react';
import { useIsMobile } from 'yoso';
import { DonBalance } from '~/components/Balance';
import { useBalance } from '~/components/Balance/Balance.hooks';
import { breakpoints } from '~/components/Breakpoint/Breakpoint.hook';
import { myCitizenItemsUrl } from '~/components/Dosi/Dosi.hooks';
import { useEmbeddedViewer } from '~/components/Embedded/Embedded.hooks';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import { useNftCount } from '~/components/Membership/Membership.hooks';
import { Link } from '~/components/Route/Link';
import myItemsStyles from '~/components/Status/Bar/StatusBarMyItems.module.scss';
import { abbreviate, format } from '~/components/Util/number';

export type AdventureStatusBarDescriptionListProps = {
  className?: string;
};

export const AdventureStatusBarDescriptionList = ({
  className,
}: AdventureStatusBarDescriptionListProps) => {
  const isMobile = useIsMobile(breakpoints);
  const { open } = useEmbeddedViewer();
  const onCitizenClick = useCallback(() => {
    open(myCitizenItemsUrl);
  }, [open]);

  const {
    data: { amount: balance },
  } = useBalance();
  const {
    data: { citizen },
  } = useNftCount({ category: 'CITIZEN' });
  const { countPerLevel = {} } = citizen || {};
  const citizenCount = useMemo(
    () =>
      Object.keys(countPerLevel).map((level) => ({
        level: Number(level.replace('lv', '')),
        count: countPerLevel[level],
      })),
    [countPerLevel]
  );

  return (
    <DescriptionList layout="responsive" className={classNames(myItemsStyles.list, className)}>
      <dt onClick={onCitizenClick}>Citizen</dt>
      <dd onClick={onCitizenClick}>
        <DescriptionList layout="inline" className={myItemsStyles.citizenList} divided>
          {citizenCount.map(({ level, count }) => (
            <Fragment key={level}>
              <dt>Lv{level}</dt>
              <dd>{format(count, { zeroAsEmpty: true })}</dd>
            </Fragment>
          ))}
        </DescriptionList>
      </dd>
      <dt>
        <Link to="/membership/don/history">DON</Link>
      </dt>
      <dd>
        <Link to="/membership/don/history">
          {balance === 0 ? '-' : <DonBalance format={isMobile ? undefined : abbreviate} />}
        </Link>
      </dd>
    </DescriptionList>
  );
};
